import React, { useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import '../../util/Quiz.css'; // Import the CSS file for QuizCard
import { Modal, Button, Card, ProgressBar, Form } from 'react-bootstrap';

const QuizCard = ({ index, quiz, handleQuizClick, deleteQuiz }) => {
    const [showModal, setShowModal] = useState(false);
    const [numQuestions, setNumQuestions] = useState(quiz.num_questions || 5); // Default value if available
    const history = useHistory();
    const role = JSON.parse(localStorage.getItem("user")).role;

    const handleShowModal = () => setShowModal(true);
    const handleCloseModal = () => setShowModal(false);

    const handleStartQuiz = () => {
        handleCloseModal();

        // Navigate to the quiz/take route with the quiz ID and number of questions
        history.push({
            pathname: `/quiz/take/${quiz._id}`,
            state: { numQuestions }  // Pass numQuestions as state
        });
    };

    const getProgressVariant = (progress) => {
        if (progress < 60) {
            return 'danger'; // Red
        } else if (progress < 80) {
            return 'warning'; // Yellow
        } else {
            return 'success'; // Green
        }
    };

    return (
        <div className="quiz-card">
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                {role === 'Instructor' ? (
                    <Link to={`/quiz/edit/${quiz._id}`} className="quiz-link">
                        <h2 className="quiz-title">{quiz.title}</h2>
                    </Link>
                ) : (
                    <span className="quiz-link" onClick={handleShowModal}>
                        <h2 className="quiz-title">{quiz.title}</h2>
                    </span>
                )}

                {role === "Instructor" && (
                    <Button
                        style={{ float: 'right', marginLeft: '10px' }}
                        onClick={(e) => {
                            e.stopPropagation();
                            deleteQuiz(quiz._id);
                        }}
                        className="btn btn-danger"
                    >
                        Delete
                    </Button>
                )}
            </div>

            <div className="quiz-info">
                <p>{`Created: ${quiz.date}`}</p>
                <p>{`Topic: ${quiz.course}`}</p>
                {role === "Student" && (
                    <div>
                        <p>Progress:</p>
                        <ProgressBar
                            now={quiz.progress}
                            label={`${Math.round(quiz.progress)}%`}
                            variant={getProgressVariant(quiz.progress)}
                            style={{ height: '1rem' }}
                        />
                    </div>
                )}
            </div>

            {/* Modal for Students to Choose Number of Questions */}
            {role === 'Student' && (
                <Modal show={showModal} onHide={handleCloseModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>Start Quiz</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form>
                            <Form.Group controlId="numQuestions">
                                <Form.Label>Number of Questions</Form.Label>
                                <Form.Control
                                    type="number"
                                    min="1"
                                    max={quiz.num_questions}
                                    value={numQuestions}
                                    onChange={(e) => setNumQuestions(e.target.value)}
                                    placeholder="Enter number of questions"
                                />
                            </Form.Group>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleCloseModal}>
                            Cancel
                        </Button>
                        <Button variant="primary" onClick={handleStartQuiz}>
                            Start Quiz
                        </Button>
                    </Modal.Footer>
                </Modal>
            )}
        </div>
    );
};

export default QuizCard;
